import HttpService from '@/servises/HttpService';
import { getEndpoint } from '@/utils/endpoints';

export default {
    getCountries: (params) => {
        return HttpService.get(getEndpoint('countries'), {
            params: params
        });
    }
};
